export default __webpack_public_path__ + "static/media/image.84b16fb4.png";